import React from 'react';
import { useForm } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface Supplier {
  id?: number;
  name: string;
}

interface Props {
  supplier?: Supplier;
  errors?: Record<string, string>;
}

export default function SupplierForm({ supplier, errors }: Props) {
  const { data, setData, post, put, processing } = useForm({
    name: supplier?.name || '',
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (supplier?.id) {
      put(`/suppliers/${supplier.id}`);
    } else {
      post('/suppliers');
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          type="text"
          value={data.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setData('name', e.target.value)}
          className="mt-1 block w-full"
          required
        />
        {errors?.name && <div className="text-red-500 text-sm mt-1">{errors.name}</div>}
      </div>

      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          {supplier?.id ? 'Update Supplier' : 'Create Supplier'}
        </Button>
      </div>
    </form>
  );
}
